import axios from 'axios';
import AUTH_CONFIG from './authConfig';
import store from 'store/store';
import { authAction } from 'containers/Login/auth.slice';
import { STATUS_CODE } from 'common/constants';
import AuthStore from 'common/authStore';

// axios.defaults.baseURL = AUTH_CONFIG.serverBasePath;

/**
 * Axios request interceptors add jwt token in headers
 */
axios.interceptors.request.use(
  function (config) {
    const _accessToken = AuthStore.accessToken;
    config.headers.Authorization = `Bearer ${_accessToken}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/**
 * Axios request interceptors add jwt token in headers
 */
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status === STATUS_CODE.TokenExpired) {
      store.dispatch({ type: authAction.setTokenExpired().type });
    }
    return Promise.reject(error);
  }
);

/**
 * Function performs axios get request
 * @param {String} url - http request url
 * @returns
 */
export function webApiGet(url) {
  return axios.get(`${AUTH_CONFIG.serverBasePath}${url}`);
}

/**
 * Function performs axios put request
 * @param {String} url - request url
 * @param {Object} options - request parameters
 * @returns
 */
export function webApiPut(url, options) {
  return axios.put(`${AUTH_CONFIG.serverBasePath}${url}`, options);
}

/**
 * Function performs axios post request
 * @param {String} url - request url
 * @param {Object} options - request parameters
 * @returns
 */
export function webApiPost(url, options) {
  return axios.post(`${AUTH_CONFIG.serverBasePath}${url}`, options);
}

/**
 * Function performs axios delete request
 * @param {String} url - request url
 * @param {Object} options - request parameters
 * @returns
 */
export function webApiDelete(url, options) {
  return axios.delete(`${AUTH_CONFIG.serverBasePath}${url}`, options);
}
